(function () {
  var MULT = 5;
  var t = null, busy = false, queued = false, lastCart = null;
  function fmtSoles(n) { return 'S/ ' + n.toFixed(2); }
  /* FIX Chiquitex 2026-10: bucle de /cart.js — escribir textContent solo si
     cambia; una escritura identica igual muta el DOM y re-dispara los observers. */
  function setText(el, v) { v = String(v); if (el && el.textContent !== v) el.textContent = v; }

  function paint(subtotalCents) {
    var pts = Math.round((subtotalCents / 100) * MULT);
    var a = document.getElementById('cx3-pts');
    var b = document.getElementById('cx3-pts-soles');
    if (a) setText(a, pts.toLocaleString('es-PE'));
    if (b) setText(b, fmtSoles(pts / 100));
  }

  /* Espejo puro de AZTech: nunca calcular tarifas propias.
     Regla: shipping_method_main PRIMERO (store_pickup => GRATIS, su tarjeta
     no expone precio); luego la tarjeta seleccionada de tipo de entrega,
     solo si esta visible y su .delivery-type-price trae texto parseable.
     Ante cualquier duda: estado 'none' (mostrar el helper, no un numero). */
  function readShipping() {
    try {
      var main = document.querySelector('input[name="shipping_method_main"]:checked');
      if (main && main.value === 'store_pickup') return { state: 'free' };
      if (!main) return { state: 'none' };
      var sel = document.querySelector('input[name="shipping_method"]:checked');
      if (!sel) return { state: 'none' };
      var card = sel.closest('.delivery-type-card');
      if (!card || card.offsetParent === null) return { state: 'none' };
      var priceEl = card.querySelector('.delivery-type-price');
      if (!priceEl) return { state: 'none' };
      var txt = (priceEl.textContent || '').trim();
      if (!txt) return { state: 'none' };
      if (/gratis/i.test(txt)) return { state: 'free' };
      var m = txt.replace(',', '.').match(/(\d+(?:\.\d+)?)/);
      if (!m) return { state: 'none' };
      var val = parseFloat(m[1]);
      if (!isFinite(val)) return { state: 'none' };
      if (val === 0) return { state: 'free' };
      return { state: 'paid', amount: val };
    } catch (e) { return { state: 'none' }; }
  }

  /* Fase 7: premium (Recojo en Agencia) sin campos de direccion.
     NO toca el snippet AZTech: observa desde fuera, oculta/muestra las filas
     y puebla/restaura los valores. El payload de AZTech lee los inputs con
     .val() al enviar, asi que el centinela llega como address1/address2.
     Auto-sanado: si el centinela aparece fuera de premium (p. ej. restaurado
     por la persistencia de AZTech), se limpia solo. Degradacion segura: si
     algun selector desaparece por una actualizacion de AZTech, no hace nada. */
  var CX7_DIR = 'RECOJO EN AGENCIA';
  var CX7_REF = 'Agencia elegida en el checkout';
  function cx7SetValue(input, value) {
    if (input.value === value) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function applyPremiumAddress() {
    try {
      var dir = document.querySelector('.page-cart input[name="Direcci\u00F3n"]');
      var ref = document.querySelector('.page-cart input[name="Referencias"]');
      if (!dir || !ref) return;
      var rowDir = document.getElementById('lbdireccion');
      var rowRef = document.getElementById('lbreferencia');
      var main = document.querySelector('input[name="shipping_method_main"]:checked');
      var sel = document.querySelector('input[name="shipping_method"]:checked');
      var premiumOn = !!(main && main.value === 'delivery' && sel && sel.value === 'premium' &&
        sel.closest('.delivery-type-card') && sel.closest('.delivery-type-card').offsetParent !== null);
      if (premiumOn) {
        if (dir.value !== CX7_DIR) dir.dataset.cx7Prev = dir.value;
        if (ref.value !== CX7_REF) ref.dataset.cx7Prev = ref.value;
        cx7SetValue(dir, CX7_DIR);
        cx7SetValue(ref, CX7_REF);
        if (rowDir && rowDir.style.getPropertyValue('display') !== 'none') rowDir.style.setProperty('display', 'none', 'important');
        if (rowRef && rowRef.style.getPropertyValue('display') !== 'none') rowRef.style.setProperty('display', 'none', 'important');
      } else {
        if (rowDir && rowDir.style.display === 'none') rowDir.style.removeProperty('display');
        if (rowRef && rowRef.style.display === 'none') rowRef.style.removeProperty('display');
        if (dir.value === CX7_DIR) {
          cx7SetValue(dir, (dir.dataset.cx7Prev !== undefined && dir.dataset.cx7Prev !== CX7_DIR) ? dir.dataset.cx7Prev : '');
        }
        if (ref.value === CX7_REF) {
          cx7SetValue(ref, (ref.dataset.cx7Prev !== undefined && ref.dataset.cx7Prev !== CX7_REF) ? ref.dataset.cx7Prev : '');
        }
      }
    } catch (e) { /* jamas romper el form */ }
  }

  function paintBreakdown() {
    var bd = document.getElementById('cx4-breakdown');
    if (!bd || !lastCart) return;
    var sub = lastCart.items_subtotal_price, tot = lastCart.total_price;
    if (typeof sub !== 'number' || typeof tot !== 'number') return;
    var subEl = document.getElementById('cx4-bd-sub');
    var descRow = document.getElementById('cx4-bd-descrow');
    var descVal = document.getElementById('cx4-bd-desc-val');
    var envioEl = document.getElementById('cx4-bd-envio');
    var help = document.getElementById('cx4-bd-help');
    var totalEl = document.getElementById('cx4-bd-total-val');
    if (!subEl || !descRow || !descVal || !envioEl || !help || !totalEl) return;
    /* FIX Chiquitex 2026-10: bucle de /cart.js — setText en vez de textContent */
    setText(subEl, fmtSoles(sub / 100));
    if (tot < sub) {
      setText(descVal, '−' + fmtSoles((sub - tot) / 100));
      descRow.hidden = false;
    } else {
      descRow.hidden = true;
    }
    var ship = readShipping();
    if (ship.state === 'paid') {
      setText(envioEl, fmtSoles(ship.amount));
      envioEl.classList.remove('cx4-free');
      help.hidden = true;
      setText(totalEl, fmtSoles(tot / 100 + ship.amount));
    } else if (ship.state === 'free') {
      setText(envioEl, 'GRATIS');
      envioEl.classList.add('cx4-free');
      help.hidden = true;
      setText(totalEl, fmtSoles(tot / 100));
    } else {
      setText(envioEl, '—');
      envioEl.classList.remove('cx4-free');
      help.hidden = false;
      setText(totalEl, fmtSoles(tot / 100));
    }
  }

  /* Fase 5.1: en movil (reorden por CSS <=1024.98px) el breakdown va DESPUES
     del Paso 1 (.page-width, como hermano en .sticky-1025 con order:41) y el
     COD despues del breakdown (order:42). Desktop mantiene las anclas de
     Fase 4. Idempotente y reversible en resize. */
  function isMobileLayout() { return window.matchMedia('(max-width: 1024.98px)').matches; }

  function place() {
    var cx = document.getElementById('cx3-chiquipuntos');
    var cod = document.getElementById('cx3-cod');
    if (!cx || !cod) return;
    var mobile = isMobileLayout();
    var bd = document.getElementById('cx4-breakdown');
    var pw = document.querySelector('.page-cart .cart-left > .sticky-1025 > .page-width');
    if (mobile && bd && pw) {
      /* movil: Paso 1 -> resumen -> COD -> Chiquipuntos (Piero 12-ago) */
      if (bd.previousElementSibling !== pw) pw.insertAdjacentElement('afterend', bd);
      if (cod.previousElementSibling !== bd) bd.insertAdjacentElement('afterend', cod);
      if (cx.previousElementSibling !== cod) cod.insertAdjacentElement('afterend', cx);
      bd.hidden = false;
    } else {
      /* desktop: anclas de Fase 4 */
      var anchorA = document.querySelector('.page-cart .js-contents_discounts');
      if (anchorA && cx.previousElementSibling !== anchorA) anchorA.insertAdjacentElement('afterend', cx);
      if (cod.previousElementSibling !== cx) cx.insertAdjacentElement('afterend', cod);
      if (bd) {
        var anchorT = document.querySelector('.page-cart .cart-info .totals');
        if (anchorT && bd.previousElementSibling !== anchorT) anchorT.insertAdjacentElement('afterend', bd);
        bd.hidden = false;
      }
    }
    cx.hidden = false;   /* fallback: si el ancla no existe, se muestran donde */
    cod.hidden = false;  /* se renderizaron - visibles siempre, jamas perdidas */
  }

  /* Fase 5.1: heading dinamico del upsell espejando el estado de la goal bar.
     Fase 6 (12-ago): tambien en desktop, aprobado por Piero. */
  function paintUpsellHeading() {
    var head = document.querySelector('.cart_page-recommend .minicart-heading');
    if (!head || !lastCart) return;
    if (!head.dataset.cx5Orig) head.dataset.cx5Orig = head.textContent.trim();
    var g = document.querySelector('.cx-goals');
    if (!g) return;
    function cents(v) { v = parseInt(v, 10) || 0; return (v > 0 && v < 10000) ? v * 100 : v; }
    var g1 = cents(g.getAttribute('data-g1'));
    var g2 = cents(g.getAttribute('data-g2'));
    var g3 = cents(g.getAttribute('data-g3'));
    var sub = lastCart.items_subtotal_price;
    var t;
    if (sub < g1)      t = 'Completa tu Envío GRATIS — Agrega ' + fmtSoles((g1 - sub) / 100) + ' más';
    else if (sub < g2) t = 'Desbloquea el Envío Express — Agrega ' + fmtSoles((g2 - sub) / 100) + ' más';
    else if (sub < g3) t = 'Desbloquea 3 cuotas sin interés — Agrega ' + fmtSoles((g3 - sub) / 100) + ' más';
    else               t = head.dataset.cx5Orig;
    setText(head, t); /* FIX Chiquitex 2026-10: bucle de /cart.js */
  }

  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      if (!document.getElementById('cx3-chiquipuntos')) return;
      place();
      paintBreakdown();
      applyPremiumAddress();
      /* FIX Chiquitex 2026-08: refuerzo anti-carrera del flag busy — un refresh
         que llega con fetch en vuelo ya no se pierde: queda en cola y se
         re-ejecuta al terminar, para no quedarnos pintando un carrito viejo. */
      if (busy) { queued = true; return; }
      busy = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        busy = false;
        if (c && typeof c.items_subtotal_price === 'number') {
          lastCart = c;
          /* Base de puntos = total_price (subtotal - todos los descuentos, sin
             envio ni impuestos), confirmada por Piero contra Smile.io 11-ago-2026 */
          paint(c.total_price);
          paintBreakdown();
          paintUpsellHeading();
          /* Fase 5 (T6): espejo de la sticky bar movil - centralizado aqui a
             pedido de Piero (sin observer aparte). Tolera anclas ausentes. */
          var stTotal = document.getElementById('cx5-sticky-total');
          var bdTotal = document.getElementById('cx4-bd-total-val');
          /* FIX Chiquitex 2026-10: bucle de /cart.js — la sticky mutaba en cada ciclo */
          if (stTotal && bdTotal) setText(stTotal, bdTotal.textContent);
          var stCount = document.getElementById('cx5-sticky-count');
          if (stCount) setText(stCount, c.item_count);
          var stBar = document.getElementById('cx5-sticky');
          if (stBar) stBar.hidden = !c.item_count;
        }
        if (queued) { queued = false; refresh(); }
      }).catch(function () {
        busy = false;
        if (queued) { queued = false; refresh(); }
      });
    }, 350);
  }

  function start() { place(); refresh(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  /* Fase 5.1: al cruzar el breakpoint (resize/rotacion) re-anclar y re-pintar */
  try {
    window.matchMedia('(max-width: 1024.98px)').addEventListener('change', function () {
      place();
      paintUpsellHeading();
    });
  } catch (e) { /* navegadores viejos sin addEventListener en MediaQueryList */ }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && (el.name === 'shipping_method' || el.name === 'shipping_method_main')) {
      applyPremiumAddress(); /* inmediato, sin esperar el debounce */
      refresh();
    }
  });

  /* Fase 7: AZTech muestra/oculta sus secciones cambiando solo el atributo
     style (sin eventos ni mutaciones de hijos) - p. ej. al volver de Retiro
     con premium aun marcado. Este observer quirurgico cubre ese hueco.
     applyPremiumAddress no escribe en estos nodos, no hay eco posible. */
  try {
    var cx7dd = document.getElementById('delivery-details');
    var cx7dtb = document.getElementById('delivery-type-block');
    if (cx7dd || cx7dtb) {
      var cx7mo = new MutationObserver(function () { applyPremiumAddress(); });
      if (cx7dd) cx7mo.observe(cx7dd, { attributes: true, attributeFilter: ['style'] });
      if (cx7dtb) cx7mo.observe(cx7dtb, { attributes: true, attributeFilter: ['style'] });
    }
  } catch (e) { /* sin el observer, el resto sigue funcionando */ }

  /* FIX Chiquitex 2026-10: bucle de /cart.js — excluir tambien lo que pinta
     refresh() fuera del resumen (la sticky y el titulo del upsell) y el
     reordenamiento de slides de los carruseles (.swiper-wrapper): la barra de
     anuncios en loop mueve nodos cada 3 s y disparaba un fetch por giro. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var tg = muts[i].target;
      if (tg && tg.closest && tg.closest('#cx3-chiquipuntos, #cx3-cod, #cx4-breakdown, #cx5-sticky, .cart_page-recommend .minicart-heading, .swiper-wrapper')) return;
    }
    refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
